module.exports = __webpack_public_path__ + "a411e23803bbc9f9b574f35a8dabaca4.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/fr/stingray_business.png
// module id = 863
// module chunks = 0